import type { ReviewCycleFilter } from "./components/ReviewCyclesFilters";

import type { GetReviewCyclesParams } from "../../../../../api/services/defs/internal-api/review-cycles";

export const getQueryParamsFromFilters = (
	filters: ReviewCycleFilter,
	searchTerm?: string
): Partial<Pick<GetReviewCyclesParams, "search" | "status" | "type" | "easyAddEnabled">> => {
	const params: Partial<Pick<GetReviewCyclesParams, "search" | "status" | "type" | "easyAddEnabled">> = {};

	if (filters?.status) {
		params.status = [filters.status.toLowerCase()] as GetReviewCyclesParams["status"];
	}

	if (filters?.reviews360?.length) {
		params.easyAddEnabled = true;
	}

	if (filters?.automation_status) {
		switch (filters.automation_status) {
			case "automated":
				params.type = "automated";
				break;
			case "non-automated":
				params.type = "manual";
				break;
		}
	}

	if (searchTerm) {
		params.search = searchTerm;
	}

	return params;
};

const SORT_FIELD_MAP: Record<string, string> = {
	name: "name",
	startDate: "startDate",
	start_date: "startDate",
	status: "status",
};

export const mapSortField = (field: string) => {
	return SORT_FIELD_MAP[field] ?? "startDate";
};
